import { useToast } from "@chakra-ui/react";
import { useRouter } from "next/dist/client/router";
import { t } from "@lingui/macro";
import { useRequest } from "../contexts/request";
import { miniGameOrderUrl, miniGameTrackPath } from "../views/MiniGames/api";

// e-wallets / cards that redirect to the gateway's own page
const REDIRECT_PAYMENTS = [
  "linkaja",
  "dana",
  "gopay",
  "shopeepay",
  "gcash",
  "paymaya",
  "grabpay",
  "alipay",
  "inter_cc",
  "linepay",
  "paypay",
  "rakutenpay",
  "merpay",
];
const VA_PAYMENTS = ["bca", "bni", "bri", "permata", "mandiri", "bjb", "bsi", "cimb"];

const errorText = (code) =>
  ({
    MINI_GAME_NOT_FOUND: t`Mini games sedang tidak tersedia.`,
    MINI_GAMES_NOT_AVAILABLE: t`Mini games sedang tidak tersedia.`,
    MINI_GAMES_DISABLED: t`Mini games sedang tidak tersedia.`,
    BANK_NOT_AVAILABLE: t`Moda pembayaran sedang tidak tersedia, silahkan pilih moda pembayaran yang lain.`,
    PAYMENT_TYPE_NOT_SUPPORTED: t`Moda pembayaran sedang tidak tersedia, silahkan pilih moda pembayaran yang lain.`,
    PHONE_NUMBER_NOT_REGISTERED: t`Nomor tidak terdaftar di sistem pembayaran OVO. Silahkan mencoba lagi dengan nomor yang lain.`,
  }[code]);

/** Mini Games ticket order: same payment routing as the store order, own endpoint + order page. */
const useMiniGameOrder = () => {
  const { post } = useRequest();
  const router = useRouter();
  const toast = useToast();

  const createOrder = async (streamerUsername, slug, { from, email, phone, ...formValues }) => {
    const { payment_type } = formValues;
    try {
      const { json } = await post(miniGameOrderUrl(streamerUsername, slug), {
        json: { ...formValues, customer_info: { first_name: from, email, phone } },
        timeout: 60000,
      });
      const { data } = json;

      // QRIS is shown on our order page, OVO asks the tipper to open the app there
      if (payment_type === "qris" || payment_type === "ovo") {
        router.push(miniGameTrackPath(data.id));
        return;
      }
      if (payment_type === "wechat_pay") {
        router.push(`/wechat/${data.payment_id}`);
        return;
      }
      if (REDIRECT_PAYMENTS.includes(payment_type) && data.redirect_url) {
        window.location.assign(data.redirect_url);
        return;
      }
      if (VA_PAYMENTS.includes(payment_type)) {
        router.push(`/va/snap/${data.id}`);
        return;
      }
      throw new Error("Something is not right with our payment gateway");
    } catch (error) {
      const title = t`Transaksi Gagal`;
      if (error.response?.status === 401) {
        toast({ title, description: t`Silahkan login terlebih dahulu.`, status: "warning", duration: 10000, isClosable: true });
        throw error;
      }
      const description =
        errorText(error.response?.json?.message) ||
        t`Ada yang salah dari sistem kami / penyedia layanan pembayaran. Cobalah beberapa saat lagi.`;
      toast({ title, description, status: "error", duration: 10000, isClosable: true });
      throw error;
    }
  };

  return { createOrder };
};

export { useMiniGameOrder };
